import { graphql, useStaticQuery } from "gatsby"

const useGetStartedLinks = () => {
  const data = useStaticQuery(
    graphql`
      {
        allIndexYaml(filter: { label: { eq: "Overview" } }) {
          edges {
            node {
              id
              label
              description
              items {
                id
                label
                url
                slug
                color
                icon
                component
                publish
                description
              }
            }
          }
        }
      }
    `
  )

  return data.allIndexYaml.edges[0].node
}

export default useGetStartedLinks
